import React from 'react';
import { Box, keyframes } from '@mui/material';

const blink = keyframes`
    0%, 80%, 100% { opacity: 0; }
    40% { opacity: 1; }
`;

/** "Typing..." with the three dots fading in turn, while the assistant's reply is on its way. */
const TypingIndicator: React.FC = () => (
    <Box role="status" aria-label="Assistant is typing">
        Typing{' '}
        {[0, 1, 2].map(i => (
            <Box
                key={i}
                component="span"
                aria-hidden
                sx={{
                    animation: `${blink} 1.4s infinite`,
                    animationDelay: `${i * 0.2}s`,
                    '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
                }}
            >
                .
            </Box>
        ))}
    </Box>
);

export default TypingIndicator;
